import React, { useContext, useEffect, useRef, useState } from "react";
import "../style/CoffeMenu.css";
import MyContext from "../context/MyContext";
import CoffeBox from "../components/Elements/CoffeBox/CoffeBox";
import IconChevronBackOutline from "../assets/icons/Arrow";

const CoffeMenu = (Props: any) => {
    const [, setIndex] = useState<number>(0);
    const { state } = useContext(MyContext)!;
    const categoryOverflow = useRef<any>(null);
    const [CoffeData , setCoffeData] = useState<any>(null);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(true);
    const [showScroll, setShowScroll] = useState(true);

    const FilterCoffeeData = (evt: React.MouseEvent<HTMLButtonElement>) => {
        const category = JSON.parse(evt.currentTarget.value);
        const index = CoffeData?.catogry.findIndex((ele:any) => ele === category);
        setIndex(index);
        Props.setDataByCategory(category === "الكل" ? ["الكل"] : Array.isArray(category) ? category : [category]);
    };

    useEffect(() => {
        if(CoffeData){
        const NewData = Props.DataByCategory.includes("الكل")
            ? CoffeData.Data
            : CoffeData.Data.filter((coffeeBox:any) =>
                Props.DataByCategory.every((category: any) =>
                    coffeeBox.category.includes(category)
                )
            );
        Props.setDataWithFilter(NewData);
    }
    }, [Props.DataByCategory, state , CoffeData]);

    const handleScroll = () => {

        if (categoryOverflow.current) {
            const { scrollLeft, scrollWidth, clientWidth } = categoryOverflow.current;
            setCanScrollLeft(scrollLeft < 0);
            setCanScrollRight(Math.floor(scrollLeft - clientWidth)*-1 < scrollWidth);
        }
    };

    const scrollToLeft = () => {
        if (categoryOverflow.current) {
            categoryOverflow.current.scrollBy({
                left: -180,
                behavior: 'smooth'
            });
        }
    };

    const scrollToRight = () => {
        if (categoryOverflow.current) {
            categoryOverflow.current.scrollBy({
                left: 180,
                behavior: 'smooth'
            });
        }
    };

    useEffect(() => {
        handleScroll(); // Initial check on component mount
        if (categoryOverflow.current) {
            categoryOverflow.current.addEventListener('scroll', handleScroll);
        }
        return () => {
            if (categoryOverflow.current) {
                categoryOverflow.current.removeEventListener('scroll', handleScroll);
            }
        };
    }, [CoffeData]); // تأكد من أن البيانات قد تم تحميلها
    

    useEffect(() => {
        if (navigator.platform.startsWith("Win") || navigator.platform.startsWith("Mac")) {
            setShowScroll(true)

        } else {
            setShowScroll(false)
        }
        try {
            fetch('./CoffeData.json')
                .then(respone => respone.json())
                .then(data => setCoffeData(data))
        } catch {
            console.log("erorr")
        }
    }, [])

    return (
        <main className="coffee-menu">
            <div className="category" >
                { canScrollLeft && <div className="arrow_btn" onClick={scrollToRight}><IconChevronBackOutline /></div>}
                <div ref={categoryOverflow} className="category-content">
                    {CoffeData?.catogry.map((category :any , index :any) => (
                        <button
                            key={index}
                            value={JSON.stringify(category)}
                            type="button"
                            onClick={FilterCoffeeData}
                            className={Props.DataByCategory.includes(category) ? "active" : undefined}
                        >
                            {category}
                        </button>
                    ))}
                </div>
                { canScrollRight && <div className="arrow_btn" onClick={scrollToLeft}><IconChevronBackOutline /> </div>}
            </div>
            {Props.DataWithFilter.length ? (
                <div className="box-content">
                    {Props.DataWithFilter.map((coffeeBox: any, index: any) => (
                        <CoffeBox FilterCoffeeData={FilterCoffeeData} key={index} data={coffeeBox} />
                    ))}
                </div>
            ) : (
                <h1 style={{ textAlign: "center" }}>لايوجد</h1>
            )}
        </main>
    );
};

export default CoffeMenu;
